<template>
    <div id="contentcontainter" class="standard-mode">
        <!-- LOADER -->
        <div v-if="!project">
            <div style="display: flex">
                <span class="circularprogress mx-auto">
                    <img id="loader" :src="getSrc()" />
                </span>
            </div>
        </div>

        <!-- SNACKBAR -->
        <v-snackbar top v-model="notification.show" :color="notification.color">
            <v-icon>{{ notification.icon }}</v-icon
            ><span class="font-weight-bold pl-2"> {{ notification.message }} </span>
        </v-snackbar>

        <!-- Persistent  SNACKBAR -->
        <v-snackbar top class="mt-5" rounded timeout="-1" v-model="persistentNotification.show" :color="persistentNotification.color" vertical style="opacity: 0.95">
            <!-- <div class="mb-1">
                <v-icon small>{{ persistentNotification.icon }}</v-icon>
            </div> -->
            <v-btn right style="top: 6px; right: 4px" absolute icon @click="persistentNotification.show = false"><v-icon>mdi-close</v-icon></v-btn>
            <div v-html="persistentNotification.message" class="mr-10"></div>
            <template v-slot:action="{ attrs }" v-if="persistentNotification.type == 'empty-cat' || persistentNotification.type == 'created-cat'">
                <v-btn
                    small
                    style="background-color: rgba(222, 222, 222, 0.395)"
                    class="mr-2 px-2"
                    rounded
                    text
                    v-bind="attrs"
                    @click="
                        showAddKwDialog.show = true
                        showAddKwDialog.category_id = persistentNotification.id
                        persistentNotification.show = false
                    ">
                    <v-icon small class="mr-1">mdi-cloud-upload</v-icon>
                    upload new
                </v-btn>
                <v-btn
                    small
                    style="background-color: rgba(222, 222, 222, 0.395)"
                    rounded
                    text
                    v-bind="attrs"
                    @click="
                        selectedComponent = 'RankingsTable'
                        activeButton = 'Rankings'
                        persistentNotification.show = false
                    ">
                    <v-icon small class="mr-1">mdi-swap-horizontal</v-icon>
                    assign existing</v-btn
                >
            </template>
            <template v-slot:action="{ attrs }" v-else>
                <v-btn style="background-color: rgba(222, 222, 222, 0.395)" rounded text v-bind="attrs" @click="persistentNotification.show = false"> OK </v-btn>
            </template>
        </v-snackbar>

        <EditProjectDialog
            v-if="editProjectDialog.show"
            :editDialog="editProjectDialog"
            @close="editProjectDialog.show = false"
            @saved="
                editProjectDialog.show = false
                fetchData($route.params.id)
            " />
        <PauseProjectDialog
            v-if="project"
            v-model="showPauseDialog"
            :project="project"
            @changed="(paused) => $set(project, 'paused', paused)"
            @notify="(message, icon, color) => (notification = $helpers.createNotification(message, icon, color))" />
        <AddKeywordsDialog
            v-if="project"
            :show="showAddKwDialog.show"
            @close="showAddKwDialog.show = false"
            @uploaded="
                showAddKwDialog.show = false
                persistentNotification = {
                    show: true,
                    message: project.paused
                        ? '<b>Keywords uploaded successfully!</b></br> The project is paused - the new keywords are fetched and use credits once you resume it. '
                        : '<b>Keywords uploaded successfully!</b></br> All data will be accesssable after the next update. ',
                    icon: 'mdi-check-circle',
                    color: 'primary'
                }
            "
            @notify="createNotification2"
            :category_id="showAddKwDialog.category_id"
            :isCategorized="project.categorized_project"
            :project_title="project.title"
            :project="project"></AddKeywordsDialog>

        <!-- HEAD -->
        <v-slide-y-transition>
            <div v-if="project">
                <span class="mt-10 ml-1" style="font-size: 12px; display: block">
                    <div class="pb-1">
                        <v-chip x-small color="" class="mr-2 px-2" style="text-transform: capitalize">
                            <v-icon x-small class="mr-1">{{ project.device == "mobile" ? "mdi-cellphone" : "mdi-monitor" }}</v-icon>
                            {{ project.device }}
                        </v-chip>
                        <v-chip x-small color="" class="mr-2 px-2" style="text-transform: uppercase">
                            <v-icon x-small class="mr-1">mdi-map-marker</v-icon>
                            {{ project.langloc.location_text }}
                        </v-chip>
                        <v-chip x-small color="" class="mr-2 px-2" style="text-transform: capitalize">
                            <v-icon x-small class="mr-1">mdi-update</v-icon>
                            {{ intervalText }}
                        </v-chip>
                        <v-chip v-if="project.paused" x-small outlined color="grey darken-1" class="mr-2 px-2">
                            <v-icon x-small class="mr-1">mdi-pause</v-icon>
                            paused
                        </v-chip>
                    </div>
                </span>
                <v-row no-gutters style="font-size: 20px" class="mb-1">
                    <v-menu style="border-radius: 25px !important" transition="scale-transition" offset-y offset-x min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn :disabled="$store.state.monitoring_suite_group.id == 2" class="px-2" v-on="on" text>{{ project.title }} <v-icon class="ml-1">mdi-chevron-down</v-icon></v-btn>
                        </template>
                        <v-list dense rounded>
                            <!-- <v-list-item disabled @click="">
                                <v-icon small class="mr-2">mdi-share</v-icon>
                                <span style="font-size: 12px"> Share Project</span>
                            </v-list-item> -->
                            <v-tooltip top :disabled="!test_set">
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">
                                        <v-list-item
                                            :disabled="test_set"
                                            @click="
                                                showAddKwDialog.show = true
                                                showAddKwDialog.category_id = category_id
                                            ">
                                            <v-icon small class="mr-2">mdi-cloud-upload</v-icon>
                                            <span style="font-size: 12px"> Add Keywords</span>
                                        </v-list-item>
                                    </span>
                                </template>
                                <span>Disabled on Example-Set</span>
                            </v-tooltip>

                            <v-tooltip top :disabled="!test_set">
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">
                                        <v-list-item
                                            :disabled="test_set"
                                            v-on="on"
                                            @click="
                                                editProjectDialog.show = true
                                                editProjectDialog.item = project
                                            ">
                                            <v-icon small class="mr-2">mdi-cog</v-icon>
                                            <span style="font-size: 12px">Project Settings</span>
                                        </v-list-item>
                                    </span>
                                </template>
                                <span>Disabled on Example-Set</span>
                            </v-tooltip>

                            <v-tooltip top :disabled="!test_set">
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">
                                        <v-list-item :disabled="test_set || initialImportRunning" @click="showPauseDialog = true">
                                            <v-icon small class="mr-2">{{ project.paused ? "mdi-play" : "mdi-pause" }}</v-icon>
                                            <span style="font-size: 12px">{{ project.paused ? "Resume Project" : "Pause Project" }}</span>
                                            <span v-if="initialImportRunning" class="ml-1" style="font-size: 11px">(import running)</span>
                                        </v-list-item>
                                    </span>
                                </template>
                                <span>Disabled on Example-Set</span>
                            </v-tooltip>
                        </v-list>
                    </v-menu>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" @click="copyReportLink" style="padding-right: 2px" color="primary" elevation="0" height="24px" width="24px" class="ml-1 my-auto" fab
                                ><v-icon x-small>mdi-share-variant</v-icon></v-btn
                            >
                        </template>
                        <span>Share Report</span>
                    </v-tooltip>
                </v-row>

                <!-- Umschalter zwischen den Kategorisierungen des Projekts.
                     Bewusst EINMAL hier unter dem Projekttitel statt in jeder Karte: die Auswahl gilt fuer
                     die ganze Ansicht, zwei Bedienstellen fuer denselben Zustand laden zum Zweifeln ein.
                     Nur sichtbar, wenn es ueberhaupt eine zusaetzliche Kategorisierung gibt. -->
                <div v-if="project.categorized_project && $store.state.monitoring_taxonomies.length" class="hierarchy-switch mb-1">
                    <div class="hierarchy-label">HIERARCHY</div>
                    <v-tabs
                        :value="taxonomyTabIndex"
                        @change="onTaxonomyTabChange"
                        height="34"
                        slider-size="3"
                        background-color="transparent"
                        show-arrows
                        class="hierarchy-tabs">
                        <v-tab class="hierarchy-tab">{{ defaultCategorizationName }}</v-tab>
                        <v-tab v-for="taxonomy in $store.state.monitoring_taxonomies" :key="taxonomy._id" :disabled="taxonomy.status !== 'ready'" class="hierarchy-tab">
                            {{ taxonomy.name }}
                            <v-chip v-if="taxonomy.status !== 'ready'" x-small class="ml-2" color="grey lighten-2">
                                {{
                                    taxonomy.status === "backfilling" && taxonomy.backfill.dates_total
                                        ? Math.round((100 * taxonomy.backfill.dates_done_count) / taxonomy.backfill.dates_total) + "%"
                                        : taxonomy.status
                                }}
                            </v-chip>
                        </v-tab>
                    </v-tabs>
                </div>
            </div>
        </v-slide-y-transition>

        <!--  CHART  -->

        <v-slide-y-transition>
            <div v-if="project" class="mt-5">
                <v-card class="rounded_card quaroshadow" style="border-top: 4px solid var(--v-primary-base); overflow: hidden" data-follow-tile="chart">
                    <v-toolbar id="projects-tool-bar" flat :color="$vuetify.theme.dark ? '' : 'blue-grey lighten-5'">
                        <v-toolbar-items>
                            <v-btn
                                v-for="chartBtn in chartBarButtons"
                                :key="chartBtn.name"
                                :class="{ 'active-button': activeChartButton === chartBtn.name }"
                                :data-follow-tab="'monchart:' + chartBtn.name"
                                @click="activeChartButton = chartBtn.name"
                                text
                                :color="activeChartButton === chartBtn.name ? 'primary' : 'grey darken-2'">
                                <v-icon class="mr-1" v-if="chartBtn.label == 'AI Overviews'" color="blue">mdi-star-four-points</v-icon> {{ chartBtn.label }}
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <!-- breadcrumb -->
                    <div class="pl-4 pa-2 breadcrumb" v-if="project.categorized_project">
                        <span><v-chip small color="primary" @click="switchCat(null)">All Categories</v-chip></span>
                        <span v-if="category_id">
                            <span v-for="(cat, index) in category_id.split(';')" :key="cat">
                                <v-icon class="px-1">mdi-chevron-right</v-icon>
                                <v-chip small color="primary" @click="setCategory(category_id, index)"> {{ cat }}</v-chip>
                            </span>
                        </span>
                    </div>
                    <v-card-text>
                        <v-slide-x-transition hide-on-leave>
                            <div v-if="activeChartButton == 'Visibility'">
                                <VisibLineChart :selectedCompetitors="selectedCompetitors" :category_id="category_id" :aio="false"></VisibLineChart>
                            </div>
                        </v-slide-x-transition>
                        <v-slide-x-transition hide-on-leave>
                            <div v-show="activeChartButton == 'Searches'">
                                <SearchesLineChart :show="activeChartButton == 'Searches'" :selectedCompetitors="selectedCompetitors" :category_id="category_id"></SearchesLineChart>
                            </div>
                        </v-slide-x-transition>
                        <v-slide-x-transition hide-on-leave>
                            <div v-show="activeChartButton == 'SERPTypes'">
                                <FrequencyLineChart
                                    :show="activeChartButton == 'SERPTypes'"
                                    :selectedSeller="project.seller"
                                    :category_id="category_id"
                                    :selectedDates="selectedDbDates"
                                    :show_ai="true"></FrequencyLineChart>
                            </div>
                        </v-slide-x-transition>
                        <v-slide-x-transition hide-on-leave>
                            <div v-if="activeChartButton == 'AIOs'">
                                <AIOLineChart v-if="new Date(project.latest_date) > new Date('2025-05-20')" :selectedCompetitors="selectedCompetitors" :category_id="category_id"></AIOLineChart>
                                <div v-else class="text-center mt-5">
                                    <v-icon color="primary" class="mr-1">mdi-clock</v-icon>
                                    <span class="text-caption">Historical Competitor AI Overview tracking will be available after this set will be updated.</span>
                                    <br />
                                    <span class="text-caption">Please check back later.</span>
                                </div>
                            </div>
                        </v-slide-x-transition>
                    </v-card-text>
                </v-card>
            </div>
        </v-slide-y-transition>
        <!-- SELECTION -->
        <v-slide-y-transition>
            <div v-if="project" class="mt-5">
                <v-card class="rounded_card quaroshadow">
                    <div class="backsheet"></div>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="8">
                                <div class="selectionCol">
                                    <div class="qsublbl">
                                        Competitors
                                        <v-tooltip max-width="250" color="" top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon v-on="on" class="pl-0 mr-auto tooltipicon" x-small color="grey lightn-2">mdi-help-circle-outline</v-icon>
                                            </template>
                                            <div>
                                                <div><b>Choose which competitors to display.</b></div>
                                                <span> By default, the four top competitors in the currently selected category are pre-selected for your convenience.</span>
                                            </div>
                                        </v-tooltip>
                                    </div>
                                    <div style="display: inline-flex">
                                        <v-autocomplete
                                            id="mon_comp_selection"
                                            append-icon="mdi-chevron-down"
                                            class="mt-2"
                                            v-model="selectedCompetitors"
                                            :items="competitors"
                                            rounded
                                            :search-input.sync="compSearchInput"
                                            filled
                                            multiple
                                            persistent-hint
                                            @input="compSearchInput = ''"
                                            hint="Type to search..."
                                            item-text="domain"
                                            return-object>
                                            <template v-slot:selection="{ item, index }">
                                                <span class="mt-2">
                                                    <span v-if="index < 10">
                                                        <!-- <v-chip>{{ item.domain }}</v-chip> -->

                                                        <v-chip class="pl-2 pr-1">
                                                            <!-- <v-icon :size="10" class="mr-1 py-auto">mdi-web</v-icon> -->
                                                            <img
                                                                class="mr-1"
                                                                style="width: 12; border-radius: 5px"
                                                                :src="'https://s2.googleusercontent.com/s2/favicons?domain=' + item.domain + '&sz=12'"
                                                                alt="" />
                                                            {{ item.domain }}
                                                            <v-btn class="ml-1" style="margin-top: 2px" x-small icon @click="selectedCompetitors.splice(index, 1)"
                                                                ><v-icon x-small>mdi-close</v-icon></v-btn
                                                            >
                                                        </v-chip>
                                                    </span>
                                                </span>

                                                <span v-if="index === 10" class="grey--text caption pt-2"> (+{{ selectedCompetitors.length - 10 }} more) </span>
                                            </template>
                                            <template v-slot:item="data">
                                                <v-row
                                                    no-gutters
                                                    :class="disabledCompetitors.has(data.item.domain) ? 'disabledComp' : ''"
                                                    style="border-bottom: 1px solid #eaeaea; border-radius: 10px; flex-wrap: nowrap !important">
                                                    <v-col class="px-0 flex" style="max-width: 90px">
                                                        <v-icon class="mx-auto" v-if="data.attrs['aria-selected'] == 'true'" color="">mdi-check-circle</v-icon>
                                                    </v-col>
                                                    <v-col class="pl-0 flex">
                                                        <v-list-item two-line>
                                                            <v-list-item-icon class="mr-5">
                                                                <div class="fav_wrapper mt-4">
                                                                    <img class="fav" :src="'https://s2.googleusercontent.com/s2/favicons?domain=' + data.item.domain + '&sz=42'" alt="" />
                                                                </div>
                                                            </v-list-item-icon>
                                                            <v-list-item-content>
                                                                <v-list-item-title>{{ data.item.domain }}</v-list-item-title>
                                                                <v-list-item-subtitle>
                                                                    <v-chip small>Visibility: {{ $helpers.formatNumber(data.item.visibility) }}</v-chip>
                                                                    <v-tooltip max-width="250" top>
                                                                        <template v-slot:activator="{ on }">
                                                                            <v-btn
                                                                                :disabled="$store.state.monitoring_suite_group.id == 2 || test_set"
                                                                                v-on="on"
                                                                                small
                                                                                icon
                                                                                class="ml-1"
                                                                                @click="disableCompetitor(data.item)"
                                                                                ><v-icon :color="disabledCompetitors.has(data.item.domain) ? 'red darken-2' : ''" small
                                                                                    >mdi-eye-off-outline</v-icon
                                                                                ></v-btn
                                                                            >
                                                                        </template>
                                                                        <span>hide competitor </span>
                                                                    </v-tooltip>
                                                                </v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-col>
                                                </v-row>
                                            </template>
                                        </v-autocomplete>
                                        <v-tooltip max-width="250" top>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" class="ma-auto ml-2" @click="selectedCompsLocked = !selectedCompsLocked" icon :color="selectedCompsLocked ? 'yellow darken-2' : ''"
                                                    ><v-icon>{{ selectedCompsLocked ? "mdi-lock" : "mdi-lock-open" }}</v-icon></v-btn
                                                >
                                            </template>
                                            <span>Competitor selection wont change while switching categories if locked.</span>
                                        </v-tooltip>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" md="4">
                                <div class="selectionCol">
                                    <div class="qsublbl">
                                        Time Range
                                        <v-tooltip max-width="250" color="" top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon v-on="on" class="pl-0 mr-auto tooltipicon" x-small color="grey lightn-2">mdi-help-circle-outline</v-icon>
                                            </template>
                                            <div>
                                                <div><b>Select time period:</b></div>
                                                <span> Specify a start and end date. The data within this range will serve as the basis for all visible data and changes.</span>
                                            </div>
                                        </v-tooltip>
                                    </div>
                                    <!-- <v-date-picker v-model="selectedDateRange" :allowed-dates="availableDates" range></v-date-picker> -->
                                    <v-menu
                                        style="border-radius: 25px !important"
                                        v-model="datepickerMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                hide-details
                                                class="mt-2"
                                                v-model="selectedDatesText"
                                                rounded
                                                filled
                                                prepend-inner-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker @input="selectedDates.sort()" color="primary" :allowed-dates="allowedDates" show-current="false" range v-model="selectedDates"></v-date-picker>
                                    </v-menu>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </div>
        </v-slide-y-transition>
        <!-- tables -->
        <v-slide-y-transition>
            <div v-if="project" class="mt-5">
                <v-card class="rounded_card my-5 quaroshadow" style="border-top: 4px solid var(--v-primary-base); overflow: hidden" data-follow-tile="table">
                    <!-- <div class="backsheet"></div> -->
                    <v-toolbar id="projects-tool-bar" flat :color="$vuetify.theme.dark ? '' : 'blue-grey lighten-5'">
                        <v-toolbar-items>
                            <v-btn
                                v-for="btn in toolbarButtons"
                                :key="btn.name"
                                :class="{ 'active-button': activeButton === btn.name }"
                                :data-follow-tab="'mon:' + btn.name"
                                @click="showComponent(btn.name)"
                                text
                                :color="activeButton === btn.name ? 'primary' : 'grey darken-2'">
                                {{ btn.label }}
                            </v-btn>
                        </v-toolbar-items>
                        <div class="flex-grow-1"></div>

                        <v-text-field
                            v-if="$vuetify.breakpoint.smAndUp"
                            class="pr-5"
                            rounded
                            dense
                            v-model="searchBounce"
                            style="max-width: 400px"
                            filled
                            clearable
                            clear-icon="mdi-close"
                            prepend-inner-icon="mdi-magnify"
                            label="Search..."
                            single-line
                            hide-details></v-text-field>
                        <!-- <v-btn rounded class="ml-auto" color="primary" filled>
                            <v-icon>mdi-cloud-download</v-icon>
                        </v-btn> -->
                        <v-btn rounded @click="initExport" class="" color="primary" filled>
                            <v-icon>mdi-cloud-download</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <!-- breadcrumb -->
                    <div class="pl-4 pa-2 breadcrumb">
                        <div v-if="project.categorized_project">
                            <span><v-chip small color="primary" @click="switchCat(null)">All Categories</v-chip></span>
                            <span v-if="category_id">
                                <span v-for="(cat, index) in category_id.split(';')" :key="cat">
                                    <v-icon class="px-1">mdi-chevron-right</v-icon>
                                    <v-chip small color="primary" @click="setCategory(category_id, index)"> {{ cat }}</v-chip>
                                </span>
                            </span>
                        </div>
                        <div v-else style="height: 24px"></div>
                    </div>
                    <v-slide-x-transition hide-on-leave>
                        <div v-if="selectedComponent == 'RankingsTable'">
                            <RankingsTable
                                :search="search"
                                :selectedCompetitors="selectedCompetitors"
                                :selectedDates="selectedDbDates"
                                :category_id="category_id"
                                :project_domain="project.domain"
                                :exportData="exportRankingsTable"
                                :categorized_project="project.categorized_project"
                                :ai_overview_project="true"
                                :project="project"
                                @showAddKwDialog="
                                    showAddKwDialog.show = true
                                    showAddKwDialog.category_id = category_id
                                "
                                @notify="createNotification2"
                                @setCategory="setCatFromTable"></RankingsTable>
                        </div>
                    </v-slide-x-transition>
                    <v-slide-x-transition hide-on-leave>
                        <div v-if="selectedComponent == 'CompetitorsTable'">
                            <CompetitorsTable :search="search" :selectedDates="selectedDbDates" :category_id="category_id" :exportData="exportCompetitorsTable"></CompetitorsTable>
                        </div>
                    </v-slide-x-transition>
                    <v-slide-x-transition hide-on-leave>
                        <div v-if="selectedComponent == 'TrendsTable'">
                            <TrendsTable
                                :search="search"
                                :category_id="category_id"
                                :project_domain="project.domain"
                                @setCategory="setCatFromTable"
                                :exportData="exportTrendsTable"
                                @notify="createNotification2"></TrendsTable>
                        </div>
                    </v-slide-x-transition>
                    <v-slide-x-transition hide-on-leave>
                        <div v-if="selectedComponent == 'ClusterTable'">
                            <ClusterTable
                                :search="search"
                                :category_id="category_id"
                                :selectedDates="selectedDbDates"
                                :project="project"
                                :project_domain="project.domain"
                                :selectedCompetitors="selectedCompetitors"
                                :exportData="exportClusterTable"></ClusterTable>
                        </div>
                    </v-slide-x-transition>
                    <v-slide-x-transition hide-on-leave>
                        <div v-if="selectedComponent == 'CategoriesTable'">
                            <CategoriesTable
                                :search="search"
                                :selectedCompetitors="selectedCompetitors"
                                :selectedDates="selectedDbDates"
                                :category_id="category_id"
                                :exportData="exportCategoriesTable"
                                :project_domain="project.domain"
                                @switchCat="switchCat"
                                @notify="createNotification2"
                                @bottomReached="showComponent('Rankings')"
                                @clearCategoryId="switchCat(null)"
                                @showAddKwDialog="
                                    (item) => {
                                        showAddKwDialog.show = true
                                        showAddKwDialog.category_id = item.category_id
                                    }
                                "></CategoriesTable>
                        </div>
                    </v-slide-x-transition>
                    <v-slide-x-transition hide-on-leave>
                        <div v-if="selectedComponent == 'CategoriesTrendsTable'">
                            <CategoriesTrendsTable
                                :search="search"
                                :selectedCompetitors="selectedCompetitors"
                                :selectedDates="selectedDbDates"
                                :category_id="category_id"
                                :exportData="exportCategoriesTrendsTable"
                                :project_domain="project.domain"
                                @switchCat="switchCat"
                                @notify="createNotification2"
                                @bottomReached="showComponent('Rankings')"
                                @clearCategoryId="switchCat(null)"
                                @showAddKwDialog="
                                    (item) => {
                                        showAddKwDialog.show = true
                                        showAddKwDialog.category_id = item.category_id
                                    }
                                "></CategoriesTrendsTable>
                        </div>
                    </v-slide-x-transition>
                </v-card>
            </div>
        </v-slide-y-transition>
    </div>
</template>

<script>
    import monitoringTaxonomy from "@/mixins/monitoringTaxonomy"
    import FrequencyLineChart from "../../components/monitoring/FrequencyLineChart"
    import VisibLineChart from "../../components/monitoring/VisibLineChart"
    import AIOLineChart from "../../components/monitoring/AIOLineChart"
    import SearchesLineChart from "../../components/monitoring/SearchesLineChart"
    import RankingsTable from "../../components/monitoring/RankingsTable"
    import CompetitorsTable from "../../components/monitoring/CompetitorsTable"
    import TrendsTable from "../../components/monitoring/TrendsTable"
    import ClusterTable from "../../components/monitoring/ClusterTable"
    import CategoriesTable from "../../components/monitoring/CategoriesTable"
    import CategoriesTrendsTable from "../../components/monitoring/CategoryTrendsTable"
    import AddKeywordsDialog from "../../components/monitoring/AddKeywordsDialog"
    import EditProjectDialog from "../../components/monitoring/EditProjectDialog.vue"
    import PauseProjectDialog from "../../components/dialogs/PauseProjectDialog.vue"
    import { intervalLabel, isInitialImportRunning } from "../../components/helper/projectStatus"
    import debounce from "lodash/debounce"
    // src/components/monitoring/VisibLineChart.vue
    export default {
        mixins: [monitoringTaxonomy],
        components: {
            FrequencyLineChart,
            VisibLineChart,
            SearchesLineChart,
            RankingsTable,
            CompetitorsTable,
            TrendsTable,
            ClusterTable,
            CategoriesTable,
            AddKeywordsDialog,
            EditProjectDialog,
            PauseProjectDialog,
            AIOLineChart,
            CategoriesTrendsTable
        },
        data() {
            return {
                compSearchInput: "",
                editProjectDialog: { show: false, item: {}, error: null },
                showPauseDialog: false,
                showAddKwDialog: { show: false, category_id: null },
                selectedCompsLocked: false,
                category_id: null,
                search: "",
                searchBounce: "",
                notification: { show: false },
                persistentNotification: { show: false },
                project: null,
                selectedComponent: "RankingsTable",
                activeButton: "Rankings",
                activeChartButton: "Visibility",
                chartBarButtons: [
                    { name: "Visibility", label: "Visibility" },
                    { name: "Searches", label: "Searches" },
                    { name: "SERPTypes", label: "SERP Types" }
                ],
                toolbarButtons: [
                    { name: "Categories", label: "Categories" },
                    { name: "Rankings", label: "Rankings" },
                    { name: "Competitors", label: "Competitors" },
                    { name: "Trends", label: "Trends" }
                ],
                selectedCompetitors: [],
                competitors: [],
                keywords: [],
                headers: [
                    {
                        text: "Project",
                        value: "title", //domain and path
                        sortable: true,
                        width: 400
                    }
                ],
                selectedDates: [],
                selectedDateRange: [],
                availableDates: [],
                datepickerMenu: false,
                disabledCompetitors: new Set(),
                exportRankingsTable: 0,
                exportCompetitorsTable: 0,
                exportTrendsTable: 0,
                exportCategoriesTable: 0,
                exportCategoriesTrendsTable: 0,
                exportClusterTable: 0
            }
        },
        methods: {
            /** Liste der zusaetzlichen Kategorisierungen des Projekts fuer den Umschalter. */
            async fetchTaxonomies(project_id) {
                try {
                    const url =
                        (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                            this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                        ) == -1
                            ? process.env.VUE_APP_MONITORING_API_URL
                            : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/taxonomy/list"
                    const response = await this.$helpers.axiosPost(url, { company_id: localStorage.company_id, project_id: project_id })
                    const taxonomies = response && response.data && response.data.taxonomies ? response.data.taxonomies : []
                    this.$store.commit("SET_MONITORING_TAXONOMIES", taxonomies)
                    return taxonomies
                } catch (error) {
                    // Der Umschalter ist ein Zusatz — faellt er aus, bleibt die Standard-Kategorisierung nutzbar.
                    console.log("Taxonomien konnten nicht geladen werden:", error)
                    this.$store.commit("SET_MONITORING_TAXONOMIES", [])
                    return []
                }
            },
            /**
             * Wechselt die aktive Kategorisierung.
             *
             * category_id MUSS zurueckgesetzt werden: ein Pfad wie "Garten;Stuehle" existiert in einer
             * anderen Kategorisierung im Allgemeinen nicht, und das Backend liefert dann stumm null
             * Treffer statt eines Fehlers.
             */
            /**
             * Tab-Wechsel auf switchTaxonomy abbilden. Der Vergleich auf den aktuellen Index ist
             * noetig, weil v-tabs @change auch bei programmatischen Wertaenderungen feuert —
             * ohne ihn wuerde ein Deep-Link oder ein Store-Update einen Wechsel ausloesen.
             */
            onTaxonomyTabChange(index) {
                if (index === this.taxonomyTabIndex) return
                const taxonomy = index === 0 ? null : this.$store.state.monitoring_taxonomies[index - 1] || null
                this.switchTaxonomy(taxonomy)
            },
            async switchTaxonomy(taxonomy) {
                if (taxonomy && taxonomy.status !== "ready") return
                this.$store.commit("SET_MONITORING_TAXONOMY", taxonomy)
                this.category_id = null

                const query = { ...this.$route.query }
                delete query.cid
                if (taxonomy) query.tid = taxonomy._id
                else delete query.tid
                this.$router.replace({ query: query }).catch(() => {})

                // Die Wettbewerber-Sets unterscheiden sich je Kategorisierung, die Auswahl muss also
                // neu bestimmt werden — auch wenn sie sonst ueber Kategoriewechsel hinweg gehalten wird.
                const wasLocked = this.selectedCompsLocked
                this.selectedCompsLocked = false
                await this.switchCat(null)
                this.selectedCompsLocked = wasLocked

                if (this.project && this.project.categorized_project) this.showComponent("Categories")
            },
            copyReportLink() {
                console.log(this.category_id)
                //add current url to clipboard
                let url = window.location.href
                if (this.category_id) {
                    // in url konform bringen
                    url = url.split("?")[0]
                    url += "?cid=" + encodeURIComponent(this.category_id)
                }
                if (this.taxonomyId) {
                    // Ein Deep-Link ohne tid wuerde die Kategorie in der Standard-Kategorisierung suchen
                    url = url.split("?")[0] + (this.category_id ? "?cid=" + encodeURIComponent(this.category_id) + "&" : "?") + "tid=" + encodeURIComponent(this.taxonomyId)
                }
                navigator.clipboard.writeText(url).then(
                    () => {
                        this.notification = this.$helpers.createNotification("Link copied to clipboard", "mdi-check-circle", "primary")
                    },
                    (err) => {
                        console.error("Could not copy text: ", err)
                    }
                )
            },
            getSrc() {
                if (this.company_id == "1547") {
                    return require("@/assets/quaro-q-obi.svg")
                } else {
                    return require("@/assets/quaro-q.svg")
                }
            },
            initExport() {
                console.log(this.selectedComponent)
                this["export" + this.selectedComponent]++
            },
            createNotification2(data) {
                console.log(data)
                if (data.type == "empty-cat" || data.type == "created-cat") {
                    this.persistentNotification = {
                        show: true,
                        message: data.label,
                        icon: data.icon,
                        color: data.color,
                        type: data.type,
                        id: data.id
                    }
                } else {
                    this.notification = this.$helpers.createNotification(data.label, data.icon, data.color)
                }
                // data : "The column title cannot contain '.'! Please try something else! ", "mdi-alert-circle-outline", "#FCBA03"
            },
            disableCompetitor(item) {
                // event.stopPropagation()
                console.log(item)
                if (!item.invisible) {
                    item.invisible = true
                    this.disabledCompetitors.add(item.domain)
                } else {
                    item.invisible = false
                    this.disabledCompetitors.delete(item.domain)
                }
                this.updateBlacklistedCompetitors()
                console.log(this.disabledCompetitors)
            },
            allowedDates(val) {
                return this.availableDates.includes(val)
            },

            async fetchData(project_id, category_id = null) {
                try {
                    //Fetch Project
                    //Fetch Competitors List
                    let data = await Promise.all([this.fetchProject(project_id), this.fetchCompetitors(project_id, category_id)])
                    console.log(data)
                    this.project = data[0]
                    // fetchData läuft nach jedem Speichern erneut - den Tab nur einmal anhängen
                    if (!this.chartBarButtons.some((button) => button.name === "AIOs")) {
                        // if (this.project.load_async_ai_overview) {
                        this.chartBarButtons.push({ name: "AIOs", label: "AI Overviews" })
                    }
                    if (this.project.categorized_project) {
                        this.activeButton = "Categories"
                        this.selectedComponent = "CategoriesTable"
                    }
                    this.applyDeepLinkView()
                    this.availableDates = [...new Set(this.project.processed_dates.map((d) => new Date(d).toISOString().substring(0, 10)))]
                    this.selectedDates = this.availableDates.slice(this.availableDates.length - 2, this.availableDates.length)
                    this.project.blacklisted_competitors.forEach((comp) => {
                        this.disabledCompetitors.add(comp)
                    })
                    this.competitors = data[1].competitors.map((comp) => {
                        comp.invisible = this.disabledCompetitors.has(comp.domain)
                        return comp
                    })

                    console.log(this.competitors)
                    // this.date_to = this.project.processed_dates[this.project.processed_dates.length - 1]
                    this.selectedCompetitors = this.project.top_competitors
                    // this.selectedCompetitors = [...this.competitors].filter((c) => c.invisible == false).slice(0, 4)
                    console.log("this.selectedCompetitors", this.selectedCompetitors)
                } catch (error) {
                    //TODO: create notification
                    console.log(error)
                }
            },
            async updateBlacklistedCompetitors() {
                try {
                    const url =
                        (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                            this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                        ) == -1
                            ? process.env.VUE_APP_MONITORING_API_URL
                            : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/update/information"
                    let post_data = {
                        company_id: localStorage.company_id,
                        project_id: this.$route.params.id,
                        fieldsToUpdate: { blacklisted_competitors: Array.from(this.disabledCompetitors) }
                    }
                    let response_data = await this.$helpers.axiosPost(url, post_data)
                    console.log(response_data)
                } catch (error) {
                    console.log(error)
                }
            },
            fetchProject(project_id) {
                return new Promise(async (resolve, reject) => {
                    try {
                        const url =
                            (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                                this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                            ) == -1
                                ? process.env.VUE_APP_MONITORING_API_URL
                                : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/one"
                        let post_data = {
                            company_id: localStorage.company_id,
                            project_id: project_id
                        }
                        let response_data = await this.$helpers.axiosPost(url, post_data)
                        resolve(response_data.data)
                    } catch (error) {
                        console.log(error)
                        reject(error)
                    }
                })
            },
            fetchCompetitors(project_id, category_id = null) {
                return new Promise(async (resolve, reject) => {
                    try {
                        const url =
                            (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                                this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                            ) == -1
                                ? process.env.VUE_APP_MONITORING_API_URL
                                : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/get/competitors/select"
                        let post_data = {
                            company_id: localStorage.company_id,
                            project_id: project_id,
                            query: { project_id: project_id, category_id: category_id },
                            fields: { visibility: { $slice: 1 }, domain: 1 },
                            sort: { "visibility.value": -1 }
                        }
                        let response_data = await this.$helpers.axiosPost(url, this.withTaxonomy(post_data))
                        resolve(response_data.data)
                    } catch (error) {
                        console.log(error)
                        reject(error)
                    }
                })
            },
            // Link aus dem KI-Chat ("Open in Quaro"): ?tab=Rankings&chart=Visibility oeffnet diese Ansicht. fetchData laeuft nach jedem
            // Speichern erneut - nur beim ersten Laden anwenden, sonst sprang die Ansicht zurueck. Ohne Parameter aendert sich nichts.
            applyDeepLinkView() {
                if (this.deepLinkViewApplied) return
                this.deepLinkViewApplied = true
                const { tab, chart } = this.$route.query
                if (["Rankings", "Competitors", "Trends", "Categories", "Cluster"].includes(tab)) this.showComponent(tab)
                if (this.chartBarButtons.some((button) => button.name === chart)) this.activeChartButton = chart
            },
            showComponent(componentName) {
                this.activeButton = componentName

                if (componentName === "Rankings") {
                    this.selectedComponent = "RankingsTable"
                } else if (componentName === "Competitors") {
                    this.selectedComponent = "CompetitorsTable"
                } else if (componentName === "Trends") {
                    this.selectedComponent = "TrendsTable"
                } else if (componentName === "Categories") {
                    this.selectedComponent = "CategoriesTable"
                } else if (componentName === "Cluster") {
                    this.selectedComponent = "ClusterTable"
                } else if (componentName === "CategorieTrends") {
                    this.selectedComponent = "CategoriesTrendsTable"
                }
            },
            setCatFromTable(category_id, index = null) {
                console.log(category_id, index)
                if (index === null) {
                    this.switchCat(category_id)
                    return
                }
                this.setCategory(category_id, index)
            },
            /**
             * sets category by index
             * @param {*} cat
             * @param {*} catindex
             */
            setCategory(category_id, catindex) {
                const cat_split = category_id.split(";")
                let newcat_split = []
                for (let index = 0; index <= catindex; index++) {
                    newcat_split.push(cat_split[index])
                }
                console.log(newcat_split.join(";"))
                this.switchCat(newcat_split.join(";"))
            },
            async switchCat(category_id, _id, categoryItem = null) {
                console.log("_id", _id)
                console.log("category_id", category_id)
                const hasMonthlyData =
                    !!categoryItem &&
                    ((Array.isArray(categoryItem.monthly_searches) && categoryItem.monthly_searches.length > 0) ||
                        Number(categoryItem.latest_12_month_search_volume || 0) > 0 ||
                        Number(categoryItem.prev_12_month_search_volume || 0) > 0)

                if (_id && !hasMonthlyData) {
                    // check if category is new and has not been updated yet.-> return
                    const objectIdString = typeof _id === "string" ? _id : _id?.$oid
                    const idTimestampDecimal = objectIdString ? parseInt(objectIdString.substring(0, 8), 16) : NaN
                    // Konvertieren des gewünschten Datums in ein Date-Objekt
                    const lastUpdatedDate = new Date(this.project.processed_dates[this.project.processed_dates.length - 1])

                    // Wenn _id nicht parsebar ist, lieber NICHT blockieren
                    if (!Number.isFinite(idTimestampDecimal)) {
                        console.warn("Could not parse category _id timestamp, skipping new-category guard", _id)
                    } else {
                        // Vergleichen Sie die Zeitstempel
                        if (idTimestampDecimal < lastUpdatedDate.getTime() / 1000) {
                            console.log("Das Dokument wurde vor dem gewünschten Datum erstellt.")
                        } else if (idTimestampDecimal === lastUpdatedDate.getTime() / 1000) {
                            console.log("Das Dokument wurde genau zu dem gewünschten Datum erstellt.")
                        } else {
                            const currentDate = new Date()
                            let nextUpdateDate

                            // Überprüfen, ob das Intervall 28, 30 oder 31 ist
                            if (this.project.interval == 28 || this.project.interval == 30 || this.project.interval == 31) {
                                if (lastUpdatedDate.getDate() > 28) {
                                    // Für Tage größer als 28
                                    if (lastUpdatedDate.getMonth() == 10) {
                                        // November (0-indexiert)
                                        nextUpdateDate = new Date(lastUpdatedDate.getFullYear() + 1, 0, 1) // 1. Januar des nächsten Jahres
                                    } else if (lastUpdatedDate.getMonth() == 11) {
                                        // Dezember
                                        nextUpdateDate = new Date(lastUpdatedDate.getFullYear() + 1, 1, 1) // 1. Februar des nächsten Jahres
                                    } else {
                                        nextUpdateDate = new Date(lastUpdatedDate.getFullYear(), lastUpdatedDate.getMonth() + 2, 1) // 1. des übernächsten Monats
                                    }
                                } else {
                                    // Für Tage kleiner als 29
                                    nextUpdateDate = new Date(lastUpdatedDate.getFullYear(), lastUpdatedDate.getMonth() + 1, lastUpdatedDate.getDate())
                                }
                            } else {
                                // Normale Berechnung für andere Intervalle
                                nextUpdateDate = new Date(lastUpdatedDate)
                                nextUpdateDate.setDate(lastUpdatedDate.getDate() + this.project.interval)
                            }

                            // Berechnen, wie viele Millisekunden bis zur nächsten Aktualisierung verbleiben
                            const timeUntilNextUpdate = nextUpdateDate - currentDate

                            // Umrechnen der Millisekunden in Tage und Stunden
                            const daysUntilUpdate = Math.floor(timeUntilNextUpdate / (24 * 60 * 60 * 1000))
                            const hoursUntilUpdate = Math.floor((timeUntilNextUpdate % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000))

                            // Anzeige der Benachrichtigung
                            this.persistentNotification = {
                                show: true,
                                message: `<h3>This category is new and has not been updated yet!</h3><p>The next update is in ${daysUntilUpdate} days and ${hoursUntilUpdate} hours.</p> `,
                                icon: "mdi-alert",
                                color: "#e5a049"
                            }
                            // this.createNotification2({
                            //     label: `This category is new and has not been updated yet! The next update is in ${daysUntilUpdate} days and ${hoursUntilUpdate} hours.`,
                            //     icon: "mdi-alert",
                            //     color: "warning"
                            // })
                            return
                        }
                    }
                }

                let data = await this.fetchCompetitors(this.$route.params.id, category_id)
                this.competitors = data.competitors.map((comp) => {
                    comp.invisible = this.disabledCompetitors.has(comp.domain)
                    return comp
                })
                this.competitors.push({})
                this.competitors.pop()
                if (!this.selectedCompsLocked) {
                    let topcomps = this.competitors.filter((c) => !c.invisible).slice(0, 4)
                    let exists = topcomps.find((c) => c.domain === this.project.domain)
                    if (!exists) {
                        let maincomp = this.competitors.find((c) => c.domain === this.project.domain)
                        if (maincomp) {
                            topcomps[3] = maincomp
                        }
                    }
                    this.selectedCompetitors = topcomps
                }
                this.category_id = category_id
            },
            setSearch: debounce(function (val) {
                this.search = val + ""
            }, 400)
        },
        watch: {
            searchBounce(val) {
                this.setSearch(val ? val : "")
            }
        },
        computed: {
            intervalText() {
                return intervalLabel(this.project && this.project.interval)
            },
            // Pausieren erst nach dem Erstimport - sonst würde nur der bereits importierte Teil gutgeschrieben
            initialImportRunning() {
                return isInitialImportRunning(this.project)
            },
            /**
             * Position der aktiven Kategorisierung in der Tab-Leiste. Index 0 ist die
             * Standard-Kategorisierung, danach die Zusatz-Taxonomien in Store-Reihenfolge.
             * Gegenstueck zu onTaxonomyTabChange — die Leiste ist damit vom Store gesteuert
             * und nicht von ihrem eigenen internen Zustand (wichtig fuer Deep-Links mit ?tid=).
             */
            /**
             * Anzeigename der Standard-Kategorisierung. Steht am Projekt, weil sie kein eigenes
             * Dokument hat — und pro Projekt, weil die Bezeichnung Kundenvokabular ist.
             */
            defaultCategorizationName() {
                return (this.project && this.project.default_categorization_name) || "Standard"
            },
            taxonomyTabIndex() {
                if (!this.taxonomyId) return 0
                const index = this.$store.state.monitoring_taxonomies.findIndex((taxonomy) => taxonomy._id === this.taxonomyId)
                return index === -1 ? 0 : index + 1
            },
            test_set() {
                return (
                    process.env.VUE_APP_MONITORING_TEST_SET_COMPANY_ID !== this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8) &&
                    !!process.env.VUE_APP_MONITORING_TEST_SET_ID && process.env.VUE_APP_MONITORING_TEST_SET_ID == this.project._id
                )
            },
            selectedDatesText() {
                return this.selectedDates.join(" ~ ")
            },
            selectedDbDates() {
                let datehelper = this.project.processed_dates.map((d) => new Date(d).toISOString().substring(0, 10))
                let firstindex = datehelper.lastIndexOf(this.selectedDates[0]) // Verwende lastIndexOf
                let secondindex = datehelper.lastIndexOf(this.selectedDates[1]) // Verwende lastIndexOf
                return [this.project.processed_dates[firstindex], this.project.processed_dates[secondindex]]
            },
            company_id() {
                return this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
            },
            lutz() {
                return this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8) == 32
            }
        },
        mounted() {
            this.$router.onReady(async () => {
                // Kontext des zuvor geoeffneten Projekts verwerfen, sonst leckt er hierher.
                this.$store.commit("SET_MONITORING_TAXONOMY", null)

                // tid VOR cid aufloesen: ein cid gehoert immer zu einer bestimmten Kategorisierung.
                // Laesst sich die tid nicht aufloesen, waere das cid in der Standard-Kategorisierung
                // im Allgemeinen ungueltig — dann wird es verworfen statt stumm ins Leere zu filtern.
                let taxonomyResolved = true
                const taxonomies = await this.fetchTaxonomies(this.$route.params.id)
                if (this.$route.query.tid) {
                    const requested = taxonomies.find((t) => t._id === this.$route.query.tid)
                    if (requested && requested.status === "ready") {
                        this.$store.commit("SET_MONITORING_TAXONOMY", requested)
                    } else {
                        taxonomyResolved = false
                        this.notification = this.$helpers.createNotification(
                            requested ? `Die Kategorisierung "${requested.name}" ist noch nicht fertig berechnet.` : "Die verlinkte Kategorisierung existiert nicht mehr.",
                            "mdi-alert",
                            "warning"
                        )
                    }
                }

                let category_id = null
                if (this.$route.query.cid && taxonomyResolved) {
                    console.log("this.$route.query.cid", this.$route.query.cid)
                    category_id = decodeURIComponent(this.$route.query.cid)
                    this.category_id = category_id
                }
                if (!["1547"].includes(this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8))) {
                    this.toolbarButtons.push({ name: "Cluster", label: "Cluster" })
                }
                if (["1547", "2"].includes(this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8))) {
                    this.toolbarButtons.push({ name: "CategorieTrends", label: "Category Trends" })
                }
                this.fetchData(this.$route.params.id, category_id)
            })
        }
    }
</script>
<style scoped>
    .circularprogress {
        margin-top: 20vh;
    }

    /* Hierarchie-Umschalter unter dem Projekttitel */
    .hierarchy-label {
        font-size: 10px;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: var(--v-secondary-lighten3, #9e9e9e);
        padding-left: 8px;
        margin-bottom: -2px;
    }
    /* Die Leiste soll wie eine Beschriftung wirken, nicht wie ein zweiter Navigationsblock:
       keine Flaeche, kein Rahmen, nur der Slider markiert die Auswahl. */
    .hierarchy-tabs >>> .v-tabs-bar {
        background-color: transparent !important;
    }
    .hierarchy-tab {
        font-size: 12px;
        letter-spacing: 0.04em;
        font-weight: 600;
    }

    .breadcrumb {
        /* background-color: white; */
        white-space: nowrap;
        border-bottom: 4px solid #edeff1;
    }
    .theme--dark .breadcrumb {
        border-bottom: 4px solid black;
    }
</style>
<style>
    .v-autocomplete__content.v-menu__content {
        border-radius: 25px !important;
    }
    .active-button {
        /* border-radius: 10px !important; */

        background-color: rgb(188, 188, 188, 0.5); /* Ändere die gewünschte Farbe */
        color: white !important; /* Ändere die Schriftfarbe */
    }
    .disabledComp {
        text-decoration: line-through;
        opacity: 0.5;
    }
    /* #projects-tool-bar .v-toolbar__content,
    .v-toolbar__extension {
        padding-left: 0px !important;
    } */
</style>
